export default __webpack_public_path__ + "static/media/both.6a87e54a.jpg";